const baseUrl = 'https://120.zhihuixingyu.com';
import util from './util.js'


import axios from 'axios';
/**
 * Get方法
 * @method {string} get
 * @url {string} url-请求地址url
 * @params {object} 请求参数
 * */
const requestFun = (method, url, data) => {
	return new Promise((resolve, reject) => {
		let headers = null;
		if(url.indexOf('http') !== 0){
			url = baseUrl + url
		}
		if (util.getStorage('token')) {
			headers = {'Authorization': util.getStorage('token')};
		}
		let opts = {method:method,url:url,data:data,headers: headers}
		if(method.toLowerCase() === 'get'){
			opts = {method:method,url:url,params:data,headers: headers}
		}
		axios(opts)
		.then(res => { resolve(res.data) })
		.catch(err => { 
			if(err.request.status === 401){
				util.loginout()
			}
			reject(err) 
		})
	})
}

const Request = {
	/**
	 * Get方法
	 * @url {string} url-请求地址url
	 * @params {object} 请求参数
	 * */
	get(url, data) {
		return requestFun('get', url, data)
	},
	/**
	 * Post方法:aplication/json
	 * @params {string}url-请求地址url
	 * @params {object}请求参数
	 * */
	post(url, data, params) {
		if (params) {
			url = url + (url.indexOf('?') == -1 ? '?' : '&')
			let path = ''
			for (let item in params) {
				path = path + '&' + item + '=' + params[item]
			}
			url = url + path.substr(1)
		}
		return requestFun('post', url, data)
	}
}

export default Request
